import { Drawer, DrawerProps } from '@mantine/core';
import React from 'react';

export interface Props extends Pick<DrawerProps, 'transitionProps'> {
	opened: boolean;
	onClose: () => void;
	title: React.ReactNode;
	className?: string;
	body?: React.ReactNode;
	position?: 'top' | 'left' | 'bottom' | 'right';
	styles?: DrawerProps['styles'];
}

export const GenericDrawer = ({
	opened,
	onClose,
	title,
	className,
	body,
	position = 'right',
	styles,
	transitionProps,
}: Props) => {
	return (
		<Drawer
			className={className}
			opened={opened}
			onClose={onClose}
			position={position}
			title={title}
			styles={styles}
			transitionProps={transitionProps}
		>
			{body}
		</Drawer>
	);
};
